import { GetterTree } from "vuex";
import {
  ReleaseNotesGetters,
  ReleaseNotesGetterNames,
  S,
  R
} from "@tt-app/types/releaseNotes/store";

export const releaseNotesGetters: GetterTree<S, R> & ReleaseNotesGetters = {
  [ReleaseNotesGetterNames.RELEASE_NOTES]: state => {
    return state.paginatedReleaseNotes?.results;
  },
  [ReleaseNotesGetterNames.IS_LOADING]: state => {
    return state.loading;
  }
};
